import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagUnsafeProps {}

const ColorTagUnsafe: React.FC<ColorTagUnsafeProps> = props => {
  return <ColorTag className="ColorTagUnsafe" color="red">Unsafe</ColorTag>
}

export default ColorTagUnsafe;